import { useEffect } from "react";
import { useParams } from "react-router";

import { getLoginClient } from "sj-ui-toolkit/src/client";
import { savePathForRedirect } from "sj-ui-toolkit/src/utils";
import { LoginAppRoutes } from "sj-ui-toolkit/src/constants/routes";

/**
 * Scorm component handles automatic IdP redirect for SCORM users
 */
export default function Scorm() {
  const { idpId, lessonKey } = useParams();
  const loginClient = getLoginClient();

  useEffect(() => {
    if (idpId) {
      redirectToIdp(idpId);
    }

    async function redirectToIdp(idp: string) {
      try {
        const response = await loginClient.redirect({
          idp,
          redirect_to: `${window.location.origin}${LoginAppRoutes.routes.samlRedirect.route}`,
        });

        if (response.data?.url) {
          if (lessonKey) {
            savePathForRedirect(`/scorm/lesson/${lessonKey}`);
          }
          window.location.href = response.data.url;
        }
      } catch (error) {
        console.error("Error redirecting to IdP for SCORM user:", error);
      }
    }
  }, [idpId, lessonKey, loginClient]);

  return null;
}
